/**
 * @generated SignedSource<<f59fe6755a2cafd021b8c648e269c0b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useHasPurchasedFromSeller_seller$data = {
  readonly buyerOrderReview?: {
    readonly __typename: "BuyerOrderReviewType";
  } | null;
  readonly " $fragmentType": "useHasPurchasedFromSeller_seller";
};
export type useHasPurchasedFromSeller_seller$key = {
  readonly " $data"?: useHasPurchasedFromSeller_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasPurchasedFromSeller_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isYouvePurchasedCalloutVariant"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasPurchasedFromSeller_seller",
  "selections": [
    {
      "condition": "isYouvePurchasedCalloutVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "BuyerOrderReviewType",
          "kind": "LinkedField",
          "name": "buyerOrderReview",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "47d37651730e2012671564cf3d53a6d1";

export default node;
